import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import LogView from '@/components/LogView'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/logView'
      // name: 'HelloWorld',
      // component: HelloWorld
    },
    {
      path: '/logView',
      name: 'LogView',
      component: LogView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js